import { useParams, Navigate } from 'react-router-dom';
import SurveyResponseDashboardContent from './SurveyResponseDashboardContent';

const PublicSurveyResponseDashboardPage = () => {
  const { eoaId } = useParams<{ eoaId: string }>();

  if (!eoaId) return <Navigate to="/login" />;

  return <SurveyResponseDashboardContent eoaId={eoaId} />;
};

export default PublicSurveyResponseDashboardPage;
